import { render, staticRenderFns } from "./complaints-detail.vue?vue&type=template&id=ae5abda2&scoped=true&"
import script from "./complaints-detail.vue?vue&type=script&lang=js&"
export * from "./complaints-detail.vue?vue&type=script&lang=js&"
import style0 from "./complaints-detail.vue?vue&type=style&index=0&id=ae5abda2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5abda2",
  null
  
)

export default component.exports